module.exports = __webpack_public_path__ + "img/1514418627.33025e05.jpg";